import OnlinePlusProfileForm from 'gcs-common/components/OnlinePlusProfileForm/OnlinePlusProfileForm';
import OnlinePlusWebWrapper from '../OnlinePlusWebWrapper';

const OnlinePlusProfileFormWeb = () => {
  return (
    <OnlinePlusWebWrapper>
      <OnlinePlusProfileForm />
    </OnlinePlusWebWrapper>
  );
};

export default OnlinePlusProfileFormWeb;
